module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Firstly, I’d like to thank Michael and Kirsten and all of Career Press for believing in me and this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’d like to thank Donn for his help with all things lawyer; everyone who participated in my polls; AshleyGAGA and Rena Havey for their expertise in blogging; Paul and Sandy and the Woman and my father, for being the most supportive parents and in-laws anyone could ask for; and Courtney, George, Tracy, Brenna, Ryan, Zayne, Lissy, and all my other dear friends who wouldn’t let me give up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most of all I want to thank my soul mate and husband, Matt, for being my rock and helping to make our dreams come true.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25ac4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 69
// module chunks = 0